export const LOCAL_STORAGE_KEY = "global_storage_key"
export const LOCAL_STORAGE_ACCOUNT_KEY = "_account"
export const LOCAL_STORAGE_SECURITY_KEY = "secutiry_global"